import {
  AppBar, Badge, colors, IconButton, Toolbar, Typography, Dialog, DialogActions, Button, Avatar
  , DialogTitle, DialogContent, DialogContentText, Popover, CardHeader, Card, Divider, CardContent, CardActions
  , Grid, Slider
} from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import { makeStyles, withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { getNotifications, notifyNotificationViewed } from 'src/store/api/notificationsApi';
import NotificationsPopover from 'src/components/NotificationsPopover';
import { baseURL, pushServerPublicKey } from 'src/utils/contants';
import { initNotifications } from 'src/modules/Notifications';
import { handleLogoutMain } from 'src/utils/Common';
import { getTasksRequest, closeAlert } from '../../store/actions';
import logo from '../../assets/images/logo--white.svg';
import { confirmAlert } from 'react-confirm-alert';
import { getUser } from 'src/utils/Common';
import { useOktaAuth } from '@okta/okta-react';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import SettingsIcon from '@material-ui/icons/Settings';
import FeedbackIcon from '@material-ui/icons/Feedback';

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""'
    }
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0
    }
  }
}))(Badge);

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  flexGrow: {
    flexGrow: 1
  },
  trialIcon: {
    marginRight: theme.spacing(1)
  },
  menuButton: {
    marginRight: theme.spacing(1)
  },
  chatButton: {
    marginLeft: theme.spacing(1)
  },
  notificationsButton: {
    marginLeft: theme.spacing(1)
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600]
  },
  logoutButton: {
    marginLeft: theme.spacing(1)
  },
  logoutIcon: {
    marginRight: theme.spacing(1)
  },
  large: {
    width: theme.spacing(15),
    height: theme.spacing(15),
    boxShadow: '0px 10px 20px rgba(0,0,0,0.3), inset 0px 0px 15px rgba(255,255,255,0.2)',
    border: '4px solid #fff',
    outline: '2px solid rgba(255, 152, 0, 0.5)',
    outlineOffset: '3px',
    transition: 'all 0.3s ease-in-out',
    backgroundColor: '#424242',
    '&:hover': {
      transform: 'scale(1.08) translateY(-5px)',
      boxShadow: '0px 15px 30px rgba(0,0,0,0.5)',
      outline: '4px solid rgba(255, 152, 0, 0.8)',
      outlineOffset: '5px',
    }
  },
  avatarWrapper: {
    position: 'relative',
    padding: theme.spacing(2),
    display: 'inline-block',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '120%',
      height: '120%',
      transform: 'translate(-50%, -50%)',
      background: 'radial-gradient(circle, rgba(255,152,0,0.15) 0%, rgba(255,255,255,0) 70%)',
      zIndex: 0,
    }
  }
}));

function TopBar({
  onOpenNavBarMobile,
  className,
  getTasksRequest,
  alertReducer,
  closeAlert
}) {
  const classes = useStyles();
  const history = useHistory();
  const notificationsRef = useRef(null);
  const locationIntervalRef = useRef(null); // Interval yönetimi için ref

  const [notifications, setNotifications] = useState([]);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const [TechnicianImage, setTechnicianImage] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const SessionUser = getUser();
  const { oktaAuth } = useOktaAuth();

  const [fontSize, setFontSize] = useState(() => parseInt(localStorage.getItem('appFontSize')) || 15);
  const [borderRadius, setBorderRadius] = useState(() => parseInt(localStorage.getItem('appBorderRadius')) || 20);

  useEffect(() => {
    document.documentElement.style.setProperty('--app-font-size', `${fontSize}px`);
    document.documentElement.style.setProperty('--app-border-radius', `${borderRadius}px`);
  }, [fontSize, borderRadius]);

  const handleRadiusChange = (event, newValue) => {
    setBorderRadius(newValue);

    try {
      localStorage.setItem(
        'appBorderRadius',
        newValue
      );
    } catch (e) {
      localStorage.removeItem('appBorderRadius');
    }
  };

  const handleFontSizeChange = (event, newValue) => {
    setFontSize(newValue);
    try {
      localStorage.setItem(
        'appFontSize',
        newValue
      );
    } catch (e) {
      localStorage.removeItem('appFontSize');
    }
  };

  const handleClickNotification = ({ ID, Url }) => {
    setShowNotificationList(false);
    notifyNotificationViewed(ID);
    getTasksRequest();

    if (Url && Url.match(baseURL)) {
      history.push(Url.replace(baseURL, ''));
    } else if (Url) {
      window.open(Url, '_blank');
    }
    setNotifications(prev => prev.filter(notification => notification.ID !== ID));
  };

  const listenServiceWorker = useCallback(() => {
    if (!('serviceWorker' in navigator) || !navigator.serviceWorker) {

      return;
    }

    const handleMessage = (event) => {
      if (!event.data || !event.data.notification) return;
      const { notification } = event.data;

      if (notification.action === 'ADD') {
        setNotifications(prev => [notification, ...prev]);
      }

      if (notification.action === 'DELETE' && notification.ID) {
        setNotifications(prev => prev.filter(ntf => ntf.ID !== notification.ID));
      }

      // if (notification.action === 'MUSTERI_IZLIYOR') {
      //   if (locationIntervalRef.current) clearInterval(locationIntervalRef.current);

      //   locationIntervalRef.current = setInterval(() => {
      //     publishLocation(notification.Title || 1);
      //   }, 10000);
      // }
    };

    navigator.serviceWorker.addEventListener('message', handleMessage);
    return () => {
      navigator.serviceWorker.removeEventListener('message', handleMessage);
      if (locationIntervalRef.current) clearInterval(locationIntervalRef.current);
    };
  }, []);

  useEffect(() => {
    setTechnicianImage(localStorage.getItem('UserPhoto'));
    initNotifications(pushServerPublicKey);
    getNotifications().then(res => {
      if (res && res.data) setNotifications(res.data);
    });

    const cleanup = listenServiceWorker();
    return () => cleanup && cleanup();
  }, [listenServiceWorker]);

  const handleDeleteAll = () => {
    setShowNotificationList(false);
    confirmAlert({
      title: 'Onay',
      message: "Tüm Bildirimleriniz Silinecektir. Onaylıyor Musunuz?",
      buttons: [
        {
          label: 'Evet',
          onClick: async () => {
            // Paralel silme işlemi
            await Promise.all(notifications.map(e => notifyNotificationViewed(e.ID)));
            const res = await getNotifications();
            if (res && res.data) setNotifications(res.data);
          }
        },
        {
          label: 'Hayır',
          onClick: () => { }
        }
      ]
    });
  };

  const Logout = async () => {
    if (oktaAuth) {
      oktaAuth.signOut();
    } else {
      handleLogoutMain();
    }
  };

  return (
    <AppBar className={clsx(classes.root, className)} style={{ background: '#424242' }}>
      <Toolbar>
        <IconButton
          style={{ color: '#FFFFFF' }}
          onClick={onOpenNavBarMobile}
          edge="start"
          data-tour="OpenNavbarButton">
          <MenuIcon />
        </IconButton>
        <RouterLink to="/overview" data-tour="ArtemisButton" style={{ position: 'relative' }}>
          <img alt="Logo" src={logo} />
          <Typography variant="subtitle2" style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-20%)',
            fontSize: '11px',
            backgroundColor: 'transparent',
            color: '#FF9800',
            padding: '4px 8px',
            borderRadius: '4px',
          }}>
            <b style={{ fontSize: '10px' }}>v.{process.env.REACT_APP_VERSION}</b>
          </Typography>
        </RouterLink>
        <div className={classes.flexGrow} />
        <IconButton onClick={() => setShowNotificationList(true)} ref={notificationsRef}>
          <Badge badgeContent={notifications.length} overlap="rectangular" color="secondary">
            <NotificationsActiveIcon style={{ color: '#FF9800' }} />
          </Badge>
        </IconButton>

        <StyledBadge
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          variant="dot"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          style={{ cursor: 'pointer', marginLeft: '8px' }}
        >
          <Avatar alt="Person" src={TechnicianImage} />
        </StyledBadge>
      </Toolbar>

      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        onClickNotification={handleClickNotification}
        onClose={() => setShowNotificationList(false)}
        open={showNotificationList}
        handleDeleteAll={handleDeleteAll}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Card style={{ minWidth: 250 }}>
          <CardHeader title={
            <Typography variant="body2" style={{ fontWeight: 'bold' }}>
              {SessionUser?.ServiceShopCode} - {SessionUser?.ServiceShopName}
            </Typography>
          } />
          <Divider />
          <CardContent>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} align="center">
                <div className={classes.avatarWrapper}>
                  <Avatar alt="Person" src={TechnicianImage} className={classes.large} />
                </div>
              </Grid>
              <Grid item xs={12} align="center">
                <Typography variant="h6">
                  {SessionUser?.UserId} - {SessionUser?.FirstName} {SessionUser?.LastName}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {SessionUser?.MobileNumber}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <CardContent>
            <Typography variant="overline" color="textSecondary" style={{ display: 'flex', alignItems: 'center' }}>
              <ZoomInIcon style={{ fontSize: 16, marginRight: 8 }} /> Yazı Boyutu ({fontSize}px)
            </Typography>
            <Slider
              value={fontSize}
              min={12}
              max={18}
              onChange={handleFontSizeChange}
              style={{ marginBottom: 16 }}
            />
            <Divider style={{ margin: '8px 0' }} />
            <Typography variant="overline" color="textSecondary" style={{ display: 'flex', alignItems: 'center' }}>
              <AspectRatioIcon style={{ fontSize: 16, marginRight: 8 }} /> Köşe Yumuşaklığı ({borderRadius}px)
            </Typography>
            <Slider
              value={borderRadius}
              min={0}
              max={24}
              onChange={handleRadiusChange}
            />
          </CardContent>
          <Divider />
          <CardActions
            style={{
              flexDirection: 'column',
              gap: '8px',
              padding: '16px',
              alignItems: 'stretch' // Butonların tam genişlikte ve aynı hizada olmasını sağlar
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              startIcon={<FeedbackIcon />}
              onClick={() => { setAnchorEl(null); history.push('/profile/1/TechnicianFeedback'); }}
              style={{ textTransform: 'none', fontWeight: 'bold', margin: 0 }} // Margin: 0 ekledik
            >
              Geri Bildirim
            </Button>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              startIcon={<SettingsIcon />}
              onClick={() => { setAnchorEl(null); history.push('/profile/1/connections'); }}
              style={{ textTransform: 'none', fontWeight: 'bold', margin: 0 }} // Margin: 0 ekledik
            >
              Ayarlar
            </Button>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={Logout}
              data-tour="LogoutButton"
              // İkonun diğerleriyle aynı tarafta olması için startIcon kullanmanızı öneririm
              startIcon={<ExitToAppIcon />}
              style={{ textTransform: 'none', margin: 0 }} // Margin: 0 ekledik
            >
              Çıkış Yap
            </Button>
          </CardActions>
        </Card>
      </Popover>

      <Dialog open={!!alertReducer.open} onClose={closeAlert}>
        <DialogTitle>{alertReducer.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{alertReducer.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeAlert} color="primary">Tamam</Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
  getTasksRequest: PropTypes.func,
  alertReducer: PropTypes.object,
  closeAlert: PropTypes.func
};

const mapStateToProps = (state) => ({
  alertReducer: state.alertReducer
});

const mapDispatchToProps = {
  getTasksRequest,
  closeAlert
};

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);